'use strict';

const template = `
		<pmt-elm ng-if="$ctrl.args" module="VerifyLocations.Resolver.Main" args="$ctrl.args"></pmt-elm>`;

function VerifyLocationResolver($stateParams, auth, pmtSiteService) {
	let $ctrl = this;

	const { site } = $stateParams;
	$ctrl.site = site;

	pmtSiteService.getSite().then(innerSite => {
		auth.getUser($stateParams.site).then(user => {
			const localAccess = { ...user.localAccess };
			const roles = localAccess.roles ? [...localAccess.roles.values()] : [];
			$ctrl.args = {
				siteName: innerSite.name,
				displayName: innerSite.displayName,
				userRoles: roles
			};
		});
	});
}

VerifyLocationResolver.$inject = ['$stateParams', 'auth', 'pmtSiteService'];

angular.module('pmtPlacesApp.directives').component('pmtVerifyLocationResolver', {
	controller: VerifyLocationResolver,
	template: template
});
